<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex';
import ComponentAverage from '@/components/ComponentAverage'
import EventBus from '../event-bus'
import { Watch } from 'vue-property-decorator'

@Component({
    components: {
        ComponentAverage
    },
    props: {
        userRole: String,
        teacherInfo: Array,
        teachers: [Array],
        fiscalYearSelected: Number,
        teacherComponents: Object
    },
    computed: {
        ...mapGetters({
            currentFiscalYear: 'getFiscalYear',
            componentsInfo: "teacher/getComponents",
        })
    }
})

export default class ComponentAveragesTable extends Vue {

    @Watch("teachers")
    onTeachersChanged(newValue) {
        this.tableData = this.createComponentsObjForTeachers(newValue)
    }

    tableData = null
    viewByAvgOrCount = 'average'
    descending = true
    sortBy = 'fiscalYear'
    dashboardType = ''

    firstColumnHeader = [
        { type: 'fiscalYear', value: 'YEAR', className: 'headers-lg teacher' },
        { type: 'name', value: 'NAME', className: 'headers-lg admin' }
    ]

    tableHeaders = [
        { type: '1a', value: '1a: Demonstrating Knowledge of Content and Pedagogy', className: 'headers'},
        { type: '1e', value: '1e: Designing Coherent Instruction', className: 'headers'},
        { type: '2a', value: '2a: Creating an Environment of Respect and Rapport', className: 'headers' },
        { type: '2d', value: '2d: Managing Student Behavior', className: 'headers' },
        { type: '3b', value: '3b: Using Questioning & Discussion Techniques', className: 'headers' },
        { type: '3c', value: '3c: Engaging Students in Learning', className: 'headers' },
        { type: '3d', value: '3d: Using Assessment in Instruction', className: 'headers' },
        { type: '4e', value: '4e: Growing & Developing Professionally', className: 'headers' }
    ]
    
    lastColumnHeader = [
        { type: 'motpScore', value: 'MOTP SCORE *', className: 'headers-lg motpScore' },
        { type: 'motpScore', value: 'SCORE TO DATE', className: 'headers-lg motpScore' }
    ]

    mounted(){

        this.setDashboardType()

        this.setTableData()

        EventBus.$on('display_count', data => {
            this.viewByAvgOrCount = 'count'
        })
        
        EventBus.$on('display_average', data => {
            this.viewByAvgOrCount = 'average'
        })

    }

    setDashboardType () {
        return this.teachers ? this.dashboardType = 'school'
            : this.userRole === 'Teacher' ? this.dashboardType = 'teacher'
            : this.dashboardType = 'adminTeacher'
    }

    setTableData () {
        if (this.dashboardType === 'school') {

            this.tableData = this.createComponentsObjForTeachers(this.teachers)

        } else {

            this.tableData = this.sortComponentsByDescFiscalYear().map(c => {
                for (let prop in c.components) {
                    c.components[prop].comments = c.components[prop].comments.filter(c => c.Rating > 0)
                    c.components[prop].description = this.tableHeaders.find(section =>
                    section.type === prop
                    ).value
                }
                return c
            })
        }
    }

    pushComponentsToArray(){
        
        let objectsArray = []
        
        let tableObjects = this.userRole === 'Teacher' ? this.componentsInfo : this.teacherComponents

        for (let prop in tableObjects) {
            objectsArray.push(tableObjects[prop])
        }
        
        return objectsArray

    }

    sortComponentsByDescFiscalYear() {

        const sortedObjects = this.pushComponentsToArray().sort(function(a, b){
            return b.fiscalYear - a.fiscalYear
        })

        return sortedObjects

    }

    createComponentsObjForTeachers(teachers){

        return teachers.map(t => {

            let components = {}
            
            const regex = /mean/

            for (let prop in t) {
                if (regex.test(prop)) {
                    let key = prop.split('_')[0].slice(-2)
                    components[key] = {
                        description: this.tableHeaders.find(section =>
                            section.type === key
                        ).value,
                        average: t[prop],
                        count: t[`component${key}_N`]
                    }
                }
            }

            t.components = components

            return t
        })

    }

    checkSortBy(type){
        return this.sortBy === type
    }
  
    sortTable(descending, type){

        if (!this.checkSortBy(type)){
            this.descending = true
        } else if (descending && this.checkSortBy) {
            this.descending = !descending
        } else if (!descending && this.checkSortBy) {
            this.descending = !descending
        }

        this.sortBy = type
        this.role = this.userRole
        this.tableData = this.tableData.sort(this.sort)

        this.$ga.event({
            eventCategory: 'Sort Component Averages Table',
            eventAction: this.sortBy,
            eventLabel: this.role
        })

    }
  
    sort(a, b){

        if (Object.keys(a).indexOf(this.sortBy) === -1){

            if (this.dashboardType === 'school' && this.sortBy === 'motpScore') {

                return this.descending ? b.SL_MOTP_Score - a.SL_MOTP_Score : a.SL_MOTP_Score - b.SL_MOTP_Score

            } else if (this.dashboardType === 'school' && this.sortBy === 'name') {

                if (this.descending) {
                    
                    return (a.LastName < b.LastName) ? 1 : (a.LastName > b.LastName) ? -1 : 0
            
                }   
                
                return (a.LastName < b.LastName) ? -1 : (a.LastName > b.LastName) ? 1 : 0

            } else if (this.dashboardType === 'school' && this.viewByAvgOrCount === 'count') {

                const aValue = a["components"][this.sortBy].count
                const bValue = b["components"][this.sortBy].count

                return this.descending ? bValue - aValue : aValue - bValue

            } else {

                const aValue = this.dashboardType !== 'school' ? a["components"][this.sortBy].data.average : a["components"][this.sortBy].average
                const bValue = this.dashboardType !== 'school' ? b["components"][this.sortBy].data.average : b["components"][this.sortBy].average
                
                return this.descending ? bValue - aValue : aValue - bValue

            }

        } else {

            return this.descending ? b[this.sortBy] - a[this.sortBy] : a[this.sortBy] - b[this.sortBy]

        }

    }

    viewObservations() {
        EventBus.$emit('view_observations')
    }

    isOnboardingStep(componentOrIndex, key) {
        return ((componentOrIndex.fiscalYear === this.currentFiscalYear || 
            componentOrIndex === 1) && 
            key === '1e')
            ? 'comp-average'
            : null
    }

}
</script>

<template>

  <div :class="this.dashboardType === 'school' ? 'admin-table' : 'teacher-table'">

    <table>

        <thead>

            <tr :class="this.dashboardType !== 'school' ? 'teacher sections' : 'admin sections'">
                <th></th>
                <th colspan="2">
                    <p>Planning &amp; Preparation</p>
                </th>
                <th colspan="2">
                    <p>Classroom Environment</p>
                </th>
                <th colspan="3">
                    <p>Instruction</p>
                </th>
                <th>
                    <p>Professional Responsibilities</p>
                </th>
            </tr>

            <tr :class="this.dashboardType !== 'school' ? 'teacher headers' : 'admin headers'">

                <th v-if="this.dashboardType !== 'school'" 
                    :class="firstColumnHeader[0].className" 
                    @click="sortTable(descending, firstColumnHeader[0].type)">  
                    <p>{{firstColumnHeader[0].value}}</p>
                </th>

                <th v-else 
                    :class="firstColumnHeader[1].className"
                    @click="sortTable(descending, firstColumnHeader[1].type)">
                    <p>{{firstColumnHeader[1].value}}</p>
                </th>


                <th v-for="header in tableHeaders" 
                    :key="header.table" 
                    @click="sortTable(descending, header.type)"
                    :class="header.className">
                    <p>{{ header.value }}</p>
                </th>
                

                <th v-if="this.dashboardType !== 'school'"
                    :class="lastColumnHeader[0].className"
                    @click="sortTable(descending, lastColumnHeader[0].type)">
                    <p>
                        {{lastColumnHeader[0].value}}
                    </p>
                </th>

                <th v-else
                    :class="lastColumnHeader[1].className"
                    @click="sortTable(descending, lastColumnHeader[1].type)">
                    <p>
                        {{lastColumnHeader[1].value}}
                    </p>
                </th>

            </tr>

        </thead>

        <tbody class="dashboard" v-if="userRole === 'Teacher' || this.teacherComponents">

            <tr v-for="component in tableData" :key="component.fiscalYear">

                <th class="first-column">
                    <p>
                        {{component.fiscalYear -1}} - {{component.fiscalYear}}
                    </p>
                </th>

                <td class="value"
                    v-for="(c, key) in component.components"
                    :key="key"
                    :id="isOnboardingStep(component, key)">
                    <ComponentAverage
                        :component="key"
                        :userRole="userRole"
                        :teacherInfo="teacherInfo"
                        :motpOption="teacherInfo.find(x=> x.FiscalYear === component.fiscalYear).MOTPOptionDescription"
                        :count="c.comments.length" 
                        :viewByAvgOrCount="viewByAvgOrCount"
                        :average="c.data.average"
                        :commentsList="c.comments"
                        :dashboardType="dashboardType"
                        :componentDescription="c.description">
                    </ComponentAverage>
                </td>

                <td class="motpScore">
                    <div class="score-to-date">
                        <p class="score">{{ component.motpScore ? component.motpScore.toFixed(2) : component.fiscalYear === 2020 ? '' : 'N/A' }}</p>
                    </div>
                </td>

            </tr>
        
        </tbody>

        <tbody class="admin-dashboard" v-else>
            <tr v-for="(teacher, index) in tableData" :key="index">
                <th class="name"
                    @click="viewObservations"
                    :id="index === 2 ? 'teacher-step' : null">
                    <router-link :to="{name: 'observations', params: {id: teacher.EmployeeID}}">
                        {{teacher.LastName}},
                        <br>
                        {{teacher.FirstName}}
                    </router-link>
                </th>           
                <td class="value" v-for="(value, prop) in teacher.components"
                    :key="prop"
                    :id="isOnboardingStep(index, prop)">
                    <ComponentAverage
                        :component="prop"
                        :componentDescription="value.description"
                        :userRole="userRole"
                        :teacherInfo="teacher"
                        :count="value.count"
                        :average="value.average"
                        :dashboardType="dashboardType"
                        :viewByAvgOrCount="viewByAvgOrCount">
                    </ComponentAverage>
                </td>
                <td class="motpScore">
                    <div v-if="teacher.SL_MOTP_Score" class="score-to-date">
                        <p class="score">{{teacher.SL_MOTP_Score.toFixed(2)}}</p>
                    </div>
                    <div v-else class="null-score-to-date">
                        <p class="score">{{ fiscalYearSelected === 2020 ||  fiscalYearSelected === 2021 ? '' : 'N/A' }}</p>
                    </div>
                </td>
            </tr>
        </tbody>

    </table>

  </div>

</template>

<style lang="scss" scoped>
    table {
        border-collapse: collapse;
        margin: 40px auto 0;
    }
    td, th {
        height: 52px;
        text-align: center;
        border: 1px solid #e5e3e6;
        border-top: none;
        &.name {
            background-color: #f0f0f0;
            text-align: left !important;
            color: #4a4a4a;
            min-width: 98px;
            max-width: 98px;
            padding: 0 10px;
            font-size: 13px;
            a {
                text-decoration: none;
                color: #4a4a4a;
                font-family: 'museo_slab', sans-serif;
                font-weight: normal;
            }
        }
        &.value,
        &.score-to-date,
        &.motpScore {
            width: 97px;
        }
    }

    .sections {
        th {
            background-color: #f0f0f0;
            font-weight: normal;	
            color: #4a4a4a;
            text-align: center;
            border: 1px solid #e5e3e6;
            border-bottom: none;
            p {
                font-size: 12px;
            }
        }
        th:first-child {
            background-color: #fff;
            border: none;
        }
        th:nth-child(2),
        th:nth-child(3) {
            width: 192px;
        }
        th:nth-child(4) {
            width: 292px;
        }
        th:last-child {
            text-align: left;
            padding-left: 10px;
            width: 85px;
            p {
                margin-left: -5px;
            }
        }
        &.admin {
            display: table;
            width: 784px;
            table-layout: fixed;
            margin-left: 118px;
        }
    }

    .headers {
        border: none;
        cursor: pointer;
        th {
            background-color: #613f75;
            text-align: left;
            padding: 0 5px;
            line-height: 1em;
        }
        th:not(:last-child) {
            border-right: 1px solid #e5e3e6;
        }
        p {
            font-size: 10px;
            color: #fff;
        }
        .headers-lg.teacher {
            background-color: #f0f0f0;
            p {
                color: #4a4a4a;
                margin-left: 5px;
            }
        }
        .headers-lg.admin {
            background-color: #613f75;
            border-top-width: 0;
            width: 108px;
            p {
                font-family: 'museo_slab', sans-serif;
                margin-left: 10px;
            }
        }
        .headers-lg.motpScore {
            text-align: center;
            border-left-width: 0;
            line-height: 21px;
        }
        .headers-lg p {
            font-size: 16px;
        }
        th:last-child {
            border-top-width: 0;
        }
        &.admin {
            display: flex;
            th {
                display: flex;
                flex-direction: column;
                height: 85px;
                width: 87px;
            }
        }
    }

    tbody {
        &.admin-dashboard {
            height: 331px;
            display: block;
            overflow: auto;
            max-width: 1018px;
        }
    }

    .first-column {
        background-color: #f0f0f0;
        color: #4a4a4a;
        font-size: 14px;
        width: 112px;
        text-align: left;
        p {
            padding-left: 10px;
        }
        .current-year-text {
            font-style: italic;
            margin-top: -10px;
        }
    }

    .motpScore {
        .score {
            font-size: 28px;
            text-align: center;
            margin: 0;
        }
        .text {
            font-size: 12px;
            color: #9b9b9b;
            font-style: italic;
            line-height: 0.92;
            text-align: center;
            margin: 0;
        }
    }

</style>